import { internalLogger } from '../../../../interface/v1/clientOsLogger';
import { getServices } from '../../../../infra/startup';

/**
 * Checks if the user is currently navigating on an onboarding path.
 * This includes both custom user onboarding paths and portal onboarding paths.
 *
 * @param userOnboardingPath - Optional custom user onboarding path to check against
 * @returns true if the user is on an onboarding path, false otherwise
 */
export default function isUserOnboardingPath(
  userOnboardingPath?: string
): boolean {
  const { navigationService, portalOnboardingService } = getServices();
  const currentPath = navigationService.location.pathname;

  if (userOnboardingPath && currentPath === userOnboardingPath) {
    /* istanbul ignore next */
    internalLogger?.debug?.('User is navigating in an user onboarding path.');
    return true;
  }

  if (portalOnboardingService.isUserOnPortalOnboardingPath()) {
    /* istanbul ignore next */
    internalLogger?.debug?.('User is navigating in an portal onboarding path.');
    return true;
  }

  return false;
}
